import * as ko from "knockout";
import entityBase from "entityBase";

export class car_dto extends entityBase {
  part_id: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  quantity: KnockoutObservable<string>;
  teams: KnockoutObservableArray<any>;

  teams_concatenated: KnockoutComputed<string>;

  constructor(item: any) {
    super();
    this.part_id = ko.observable(item?.part_id);
    this.description = ko.observable(item?.description || item?.part?.internal_descriptn || item?.internal_descriptn);
    this.quantity = ko.observable(item?.quantity);
    this.model_id = ko.observable(item?.model_id || item?.part?.model_id);
    this.teams = ko.observableArray(item?.teams);

    this.teams_concatenated = ko.computed(() => {
      const res = this.teams().map((t) => (t.description ? t.description : t.team_id));

      return res.join(",\n");
    });
  }
}
